export default __webpack_public_path__ + "static/media/char_body_prem_005.7e2a647f.png";